import { formatTime } from '../utils/formatTime'
import styles from './AdOverlay.module.css'

interface Props {
  visible: boolean
  title: string
  currentTime: number
  duration: number
  skipRemaining: number
  canSkip: boolean
  onSkip: () => void
  onClickThrough: () => void
}

export function AdOverlay({
  visible,
  title,
  currentTime,
  duration,
  skipRemaining,
  canSkip,
  onSkip,
  onClickThrough,
}: Props) {
  if (!visible) return null

  return (
    <div className={styles.overlay}>
      <div className={styles.top}>
        <span className={styles.badge}>Ad</span>
        <button type="button" className={styles.title} onClick={onClickThrough}>
          {title}
          <span className={styles.learn}>Learn more</span>
        </button>
        <span className={styles.countdown}>
          {formatTime(Math.max(0, duration - currentTime))}
        </span>
      </div>

      <div className={styles.skipWrap}>
        {canSkip ? (
          <button type="button" className={styles.skip} onClick={onSkip}>
            Skip Ad
            <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden>
              <path fill="currentColor" d="M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z" />
            </svg>
          </button>
        ) : (
          <div className={styles.skipLocked}>Skip in {skipRemaining}s</div>
        )}
      </div>
    </div>
  )
}
